import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { mq, ScreenSize } from '../../styles/mq';

export const MenuLineOld = styled.div`
  position: absolute;
  left: 4rem;

  ${mq.medium} {
    left: 7rem;
  }
  top: 2rem;
  height: calc(100% - 4rem);
  border-left: 1px dashed ${theme.colors.text};
`;

export const MenuWrapper = styled.div`
  counter-reset: menu;
  margin-top: 1rem;
  margin-bottom: 8rem;
  ${mq.medium} {
    margin-bottom: 12rem;
  }
`;

export const MenuLine = styled.div`
  position: absolute;
  width: 100%;
  max-width: ${ScreenSize.MD / 10}rem;

  ${mq.medium} {
    padding: 0 4rem;
    max-width: calc(740px + 11rem);
  }
  ${mq.large} {
    max-width: calc(${ScreenSize.MD / 10}rem + 30rem);
  }
  margin: 0 auto;
  top: 2rem;
  left: 0;
  right: 0;
  height: calc(100% - 4rem);
  &::before {
    position: absolute;
    content: '';
    height: 100%;
    display: block;
    border-left: 1px dashed ${theme.colors.text};
    left: 3.5rem;
    ${mq.medium} {
      left: 6.5rem;
    }
    ${mq.xlarge} {
      left: 7.5rem;
    }
  }
`;
